export const PENDING = "#FFD966";
export const PENDING_HOVER = "#4EC5BA";
export const PENDING_NAME = "Pending";

export const NEW = "#A3E4D7";
export const NEW_HOVER = "#E2D69B";
export const NEW_NAME = "New";

export const APPROVED = "#85C1E9";
export const APPROVED_HOVER = "#D2C3B8";
export const APPROVED_NAME = "Approved";

export const SCHEDULED = "#F8C471";
export const SCHEDULED_HOVER = "#C8B8A6";
export const SCHEDULED_NAME = "Schedule Date";

export const REACHED_FACILITY = "#BB8FCE";
export const REACHED_FACILITY_HOVER = "#BFA59F";
export const REACHED_FACILITY_NAME = "Reached Facility";

export const REPORT_AVAILABLE = "#D7EDCE";
export const REPORT_AVAILABLE_HOVER = "#B7E1B8";
export const REPORT_AVAILABLE_NAME = "Report Available";

export const PROCESSING_DONE = "#BCE3C4";
export const PROCESSING_DONE_HOVER = "#A3D3B2";
export const PROCESSING_DONE_NAME = "Processing Done";

export const REPORTING_DONE = "#5DADE2";
export const REPORTING_DONE_HOVER = "#6BAE97";
export const REPORTING_DONE_NAME = "Reporting Done";

export const COD_DONE = "#5FD88E";
export const COD_DONE_HOVER = "#52C77A";
export const COD_DONE_NAME = "COD Done";

export const COMPLETED = "#58D68D";
export const COMPLETED_HOVER = "#B3D75A";
export const COMPLETED_NAME = "Completed";

export const CANCEL = "#E6B0AA";
export const CANCEL_HOVER = "#B3D75A";
export const CANCEL_NAME = "Cancel";

export const OTHERS = "#D5DBDB";
export const OTHERS_HOVER = "#B3D75A";
export const OTHERS_NAME = "Others";

export const QUOTE_REQUESTED = "#D5DBDB";
export const QUOTE_REQUESTED_HOVER = "#B3D75A";
export const QUOTE_REQUESTED_NAME = "Quote Requested";

export const QUOTE_COMPLETED = "#D5DBDB";
export const QUOTE_COMPLETED_HOVER = "#B3D75A";
export const QUOTE_COMPLETED_NAME = "Quote Completed";

export const QUOTATION_SENT = "#D5DBDB";
export const QUOTATION_SENT_HOVER = "#B3D75A";
export const QUOTATION_SENT_NAME = "Quotation Sent";

export const QUOTE_ACCEPTED = "#D5DBDB";
export const QUOTE_ACCEPTED_HOVER = "#B3D75A";
export const QUOTE_ACCEPTED_NAME = "Quote Accepted";

export const QUOTE_DECLINED = "#D5DBDB";
export const QUOTE_DECLINED_HOVER = "#B3D75A";
export const QUOTE_DECLINED_NAME = "Quote Declined";

export const COD_COMPLETED = "#D5DBDB";
export const COD_COMPLETED_HOVER = "#B3D75A";
export const COD_COMPLETED_NAME = "COD Completed";

export const DONATION_SENT = "#D5DBDB";
export const DONATION_SENT_HOVER = "#B3D75A";
export const DONATION_SENT_NAME = "Donation Sent";

export const SCHEDULE_DATE = "#D5DBDB";
export const SCHEDULE_DATE_HOVER = "#B3D75A";
export const SCHEDULE_DATE_NAME = "Schedule Date";

export const DELIVERED_DATE = "#D5DBDB";
export const DELIVERED_DATE_HOVER = "#B3D75A";
export const DELIVERED_DATE_NAME = "Delivered Date";

export const PACKING_INITIATED = "#D5DBDB";
export const PACKING_INITIATED_HOVER = "#B3D75A";
export const PACKING_INITIATED_NAME = "Packing Initiated";

export const AUDIT_BOOKING_REPORT = "#D5DBDB";
export const AUDIT_BOOKING_REPORT_HOVER = "#B3D75A";
export const AUDIT_BOOKING_REPORT_NAME = "Audit/Booking Report";

export const BOOKING_REPORTS = "#D5DBDB";
export const BOOKING_REPORTS_HOVER = "#B3D75A";
export const BOOKING_REPORTS_NAME = "Booking Reports";

export const RECEPTION_REPORTS = "#D5DBDB";
export const RECEPTION_REPORTS_HOVER = "#B3D75A";
export const RECEPTION_REPORTS_NAME = "Reception Reports";

export const RECYCLING_RECEPTION_REPORTS = "#D5DBDB";
export const RECYCLING_RECEPTION_REPORTS_HOVER = "#B3D75A";
export const RECYCLING_RECEPTION_REPORTS_NAME = "Recycling Reception Reports";

export const REVENUE_SHARE_REPORTS = "#D5DBDB";
export const REVENUE_SHARE_REPORTS_HOVER = "#B3D75A";
export const REVENUE_SHARE_REPORTS_NAME = "Revenue Share Reports";

export const SERVICEFEE_BOOKING_REPORTS = "#D5DBDB";
export const SERVICEFEE_BOOKING_REPORTS_HOVER = "#B3D75A";
export const SERVICEFEE_BOOKING_REPORTS_NAME = "Servicefee Booking Reports";

export const SETTLEMENT_REPORTS = "#D5DBDB";
export const SETTLEMENT_REPORTS_HOVER = "#B3D75A";
export const SETTLEMENT_REPORTS_NAME = "Settlement Reports";

export const VALUE_BACK_REPORTS = "#D5DBDB";
export const VALUE_BACK_REPORTS_HOVER = "#B3D75A";
export const VALUE_BACK_REPORTS_NAME = "Value Back Reports";

export const PENDING_FOR_COLLECTION = "#D5DBDB";
export const PENDING_FOR_COLLECTION_HOVER = "#B3D75A";
export const PENDING_FOR_COLLECTION_NAME = "Pending for Collection";

export const PENDING_EXPORT_TO_SG = "#D5DBDB";
export const PENDING_EXPORT_TO_SG_HOVER = "#B3D75A";
export const PENDING_EXPORT_TO_SG_NAME = "Pending export to SG";

export const PENDING_EXPORT_PCBA_TO_SG = "#D5DBDB";
export const PENDING_EXPORT_PCBA_TO_SG_HOVER = "#B3D75A";
export const PENDING_EXPORT_PCBA_TO_SG_NAME = "Pending export PCBA to SG";

export const IN_TRANSIT = "#D5DBDB";
export const IN_TRANSIT_HOVER = "#B3D75A";
export const IN_TRANSIT_NAME = "In transit";

export const PROCESSING = "#D5DBDB";
export const PROCESSING_HOVER = "#B3D75A";
export const PROCESSING_NAME = "Processing";

export const READY_FOR_SETTLEMENT = "#D5DBDB";
export const READY_FOR_SETTLEMENT_HOVER = "#B3D75A";
export const READY_FOR_SETTLEMENT_NAME = "Ready for Settlement";

export const PENDING_PO_INVOICE = "#D5DBDB";
export const PENDING_PO_INVOICE_HOVER = "#B3D75A";
export const PENDING_PO_INVOICE_NAME = "Pending PO/invoice";

export const SETTLEMENT_CLOSED = "#D5DBDB";
export const SETTLEMENT_CLOSED_HOVER = "#B3D75A";
export const SETTLEMENT_CLOSED_NAME = "Settlement Closed";

export const PROCESSING_STARTED = "#D5DBDB";
export const PROCESSING_STARTED_HOVER = "#B3D75A";
export const PROCESSING_STARTED_NAME = "Processing Started";

export const PREPARING_FOR_SETTLEMENT = "#D5DBDB";
export const PREPARING_FOR_SETTLEMENT_HOVER = "#B3D75A";
export const PREPARING_FOR_SETTLEMENT_NAME = "Preparing for settlement";